import type { AxiosError } from "axios"
import { AuthService } from "../services/auth.service"
import { i18n } from "../../internationalize/i18n.service"

export class SignInView {
  sentCallBack: Function
  sendBtn: HTMLButtonElement
  emailInput: HTMLInputElement
  errorElem: HTMLElement

  constructor(public element: HTMLElement, sentCallBack: Function, private authService: AuthService = window.tbwServices.authService) {
    this.sentCallBack = sentCallBack

    const emailDisplayElem = element.querySelector<HTMLElement>("#otp-send-email")
    const emailInput = element.querySelector<HTMLInputElement>('input[type=email')
    const sendBtn = element.querySelector<HTMLButtonElement>('button.send-email')
    const errorElem = element.querySelector<HTMLElement>('.error-container')

    if (!emailInput || !emailDisplayElem || !sendBtn || !errorElem) { throw new Error("Element(s) missing") }
    this.emailInput = emailInput
    this.sendBtn = sendBtn
    this.errorElem = errorElem

    this.emailInput.addEventListener('input', this.onEmailChanged)
    this.sendBtn.addEventListener('click', this.onSendEmailBtnClick)

    this.errorElem.hidden = true
  }

  open() {
    this.emailInput.disabled = false
    this.sendBtn.disabled = true
    this.emailInput.value = ''
  }

  onEmailChanged = (e: Event) => {
    const input = e.target as HTMLInputElement
    this.sendBtn.disabled = !input.checkValidity()
    this.errorElem.hidden = true
  }

  onSendEmailBtnClick = async (_: MouseEvent) => {
    this.sendBtn.disabled = this.emailInput.disabled = true
    const email = this.emailInput.value.trim()
    this.sendBtn.disabled = this.emailInput.disabled = false
    this.sendBtn.disabled = this.emailInput.disabled = true
    try {
      await this.authService.sendEmail(email)
      this.sentCallBack(email)
    } catch (error) {
      this.handleError(error as AxiosError)
    } finally {
      this.sendBtn.disabled = this.emailInput.disabled = false
    }
  }

  handleError(error: AxiosError) {
    const errorMessage = this.errorElem.querySelector("#error-message")
    if(!errorMessage) { return }

    if(error.response?.status === 404) {
      errorMessage.innerHTML = i18n.t("email_not_found")
    } else {
      errorMessage.innerHTML = i18n.t("server_error")
    }

    this.errorElem.style.display = 'flex';
    this.errorElem.hidden = false
  }
}
